<template>
    <body>
    <div class="my">
        <h1>Not found page</h1>
        <div class="micon"><i class="fa fa-ban" aria-hidden="true"></i></div>
        <h2>Please use the top right menu icon...</h2>
    </div>
    </body>
</template>
<style scoped lang="scss">
    body {
        height: 100vh;
        background-color: lightslategrey;
    }
    .micon {
        font-size: 50px;
    }
    .my {
        padding-top: 10%;
        font-size: 20px;
    }
</style>